/* Skillz Cutz Premium — global behavior */
(function () {
  'use strict';

  /* ---- Regional pricing (₦ for Nigeria, AED for UAE) ----
     Detected from the device's timezone — zero network calls, so it can't be
     rate-limited or ad-blocked. Elements opt in via data-price-ngn/data-price-aed. */
  var region = 'ngn';
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Asia/Dubai') region = 'aed'; /* UAE only — the studio's second city */
  } catch (e) { /* very old browsers: default to ₦ */ }
  document.documentElement.setAttribute('data-region', region);

  function applyPrices(scope, reg) {
    scope.querySelectorAll('[data-price-ngn]').forEach(function (el) {
      var v = reg === 'aed' ? el.getAttribute('data-price-aed') : el.getAttribute('data-price-ngn');
      if (v) el.textContent = v;
    });
  }
  window.SKZ_applyPrices = applyPrices;
  applyPrices(document, region);

  /* ---- Sticky header state ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var headerTicking = false;
    var onScroll = function () {
      if (headerTicking) return;
      headerTicking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 12);
        headerTicking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('MobileDrawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  if (drawer && openBtn) {
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');
    var setOpen = function (open) {
      drawer.classList.toggle('is-open', open);
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    openBtn.addEventListener('click', function () { setOpen(true); });
    closeEls.forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---- Reveal on scroll ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Give the hero image the first paint before loading visible videos.
     Only ONE video is ever decoding at a time: the reel puts several cards on
     screen at once, and playing them all was the main source of scroll jank on
     phones. We track visibility ratios and run only the most-visible clip;
     every other one is paused and its source is never even fetched. */
  function observeVideos() {
    var vids = document.querySelectorAll('video[data-autoplay-video]');
    if (!vids.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    function prepare(v) {
      if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; }
      var source = v.querySelector('source[data-src]');
      if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); v.load(); }
    }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { prepare(v); v.controls = true; });
      return;
    }
    var ratios = new Map();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
      var best = null;
      var bestRatio = 0;
      ratios.forEach(function (ratio, v) {
        if (ratio > bestRatio) { bestRatio = ratio; best = v; }
      });
      ratios.forEach(function (ratio, v) {
        if (v === best && bestRatio >= 0.25) {
          prepare(v);
          v.controls = true;
          if (!reduceMotion && !saveData) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    vids.forEach(function (v) { observer.observe(v); });
  }
  function afterHeroPaint() { requestAnimationFrame(function () { requestAnimationFrame(observeVideos); }); }
  var heroImage = document.querySelector('.hero__media img');
  if (heroImage && !heroImage.complete) {
    heroImage.addEventListener('load', afterHeroPaint, { once: true });
    heroImage.addEventListener('error', afterHeroPaint, { once: true });
  } else afterHeroPaint();

  /* ---- Animated counters ---- */
  var counters = document.querySelectorAll('[data-count-to]');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var duration = 1600;
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min, 10) || 0;
    var next = (parseInt(input.value, 10) || min) + delta;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Cart page: submit update on quantity change ---- */
  document.querySelectorAll('[data-cart-form] .qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---- Product gallery thumbs ---- */
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      var src = thumb.getAttribute('data-src');
      var srcset = thumb.getAttribute('data-srcset');
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---- Product variant picker ---- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var dataEl = document.getElementById('ProductVariantsJson');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var selects = productForm.querySelectorAll('[data-option-select]');
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyBtn = productForm.querySelector('[data-add-to-cart]');

    var syncVariant = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
      if (buyBtn) {
        buyBtn.disabled = !match.available;
        buyBtn.textContent = match.available ? buyBtn.getAttribute('data-label-add') : buyBtn.getAttribute('data-label-soldout');
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    if (selects.length) syncVariant();
  }
})();
